import { Controller } from '@hotwired/stimulus'

import { dispatcher } from './pub_controller'

export class DeviceShowController extends Controller {
  static values = { modalUrl: String, showFullCheck: Boolean }

  declare modalUrlValue: string
  declare showFullCheckValue: boolean

  connect() {
    if (this.showFullCheckValue) {
      window.setTimeout(() => {
        dispatcher(this, 'turbo-modal-get', 'turbo-modal', this.modalUrlValue)
      }, 0)
    }
  }
}
